import { render, staticRenderFns } from "./housekeepingFeeConfigManage.vue?vue&type=template&id=f3bb2ec2&scoped=true"
import script from "./housekeepingFeeConfigManage.vue?vue&type=script&lang=js"
export * from "./housekeepingFeeConfigManage.vue?vue&type=script&lang=js"
import style0 from "./housekeepingFeeConfigManage.vue?vue&type=style&index=0&id=f3bb2ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bb2ec2",
  null
  
)

export default component.exports